import { DateFormatter } from '@repo/toolkit/date'
import Box from '@repo/ui/box'
import Loader from '@repo/ui/loader'
import Rating from '@repo/ui/rating'
import Typography from '@repo/ui/typography'
import { useQuery } from '@tanstack/react-query'

import { getMissionToStaffReport } from '../../../api/mission-to-staffs/get-mission-to-staff-report'
import useTranslate from '../../../lib/hooks/use-translate'
import { StaffMissionReportHeader } from '../../../views/staff-personal-space/staff-mission-report-header'
import { ItemNotFound } from '../../elements/item-not-found'

type Props = {
  missionToStaffId: number
  className?: string
}
const MissionToStaffReportView = ({ missionToStaffId, className }: Props) => {
  const { t } = useTranslate()
  const { data, isPending } = useQuery({
    queryKey: ['mission-to-staff-report', missionToStaffId],
    queryFn: getMissionToStaffReport.bind(null, missionToStaffId)
  })

  if (isPending) return <Loader center />
  if (!data) return <ItemNotFound title="Rapport de mission non trouvé" />

  return (
    <div className={className}>
      <StaffMissionReportHeader missionToStaffId={missionToStaffId} version="multilines" />
      <div className="h-3" />
      <Box className="border border-grey-light flex flex-col gap-4 rounded-lg">
        <div className="flex gap-6">
          <div>
            <Typography variant="secondary-body" className="text-grey-lighter">
              {t('staff.personal.space.missions.report.start.time')}
            </Typography>
            <Typography variant="tag">{DateFormatter.getFormattedTime(data.startTime)}</Typography>
          </div>

          <div>
            <Typography variant="secondary-body" className="text-grey-lighter">
              {t('staff.personal.space.missions.report.end.time')}
            </Typography>
            <Typography variant="tag">{DateFormatter.getFormattedTime(data.endTime)}</Typography>
          </div>
        </div>

        <div>
          <Typography variant="label-semibold">
            {t('staff.personal.space.missions.report.content.title')}
          </Typography>
          <div className="h-1" />
          <Typography variant="label" className="text-grey-lighter">
            {data.content || t('common.no.comments')}
          </Typography>
        </div>

        <div>
          <Typography variant="label-semibold">
            {t('staff.personal.space.missions.report.comments.title')}
          </Typography>
          <div className="h-1" />
          <Rating mode="view" defaultValue={data.rating || 0} />
          <Typography variant="label" className="text-grey-lighter">
            {data.comments || t('common.no.feedback')}
          </Typography>
        </div>
      </Box>
    </div>
  )
}

export default MissionToStaffReportView
